import intl from 'react-intl-universal';

interface MenuItem {
  id: string;
  name: string;
  path: string;
  children?: MenuItem[];
  icon?: string;
}

interface AuthMenuMap {
  id: string;
  name: string;
  secondMenuPath: string;
  icon: string;
}

interface ShortcutMenuItem {
  menu: [string, string] | [];
  key: string;
  path?: string;
  func?: string;
}

// 门店功能列表
export const SHOP_FUNC_LIST = [
  { value: 'newReservation', label: intl.get('drawer_reserve_create_title') },
  { value: 'newCheckIn', label: intl.get('drawer_checkin_create_title') },
  { value: 'newMemberCard', label: intl.get('order_action_new_apply_for_memberCard') },
  { value: 'centralReservation', label: intl.get('order_submenu_crsInvitation') },
  {
    value: 'readRoomCard',
    label: intl.get('app_read_room_card'),
  },
  { value: 'handover', label: intl.get('app_exchange_shift') },
];

export const FUNCTION_ICON = {
  newReservation: 'icon-xinyuding',
  newCheckIn: 'icon-xinruzhu',
  newMemberCard: 'icon-xinbanhuiyuanka',
  centralReservation: 'icon-zhongyangyudingyaoqingdan1',
  readRoomCard: 'icon-dufangka1',
  handover: 'icon-jiaoban1',
};

export const handleMenuAuth = (
  exitMenu: ShortcutMenuItem[],
  authMenu: MenuItem[],
): ShortcutMenuItem[] => {
  // 使用 Map 替代普通对象，提高查找性能
  const authSecondMenuKeyMap = new Map<string, AuthMenuMap>();

  // 构建二级菜单映射
  authMenu.forEach((parentMenu) => {
    parentMenu.children?.forEach((childMenu) => {
      authSecondMenuKeyMap.set(String(childMenu.id), {
        id: parentMenu.id,
        name: `${parentMenu.name} - ${childMenu.name}`,
        secondMenuPath: childMenu.path,
        icon: childMenu.icon,
      });
    });
  });

  // 过滤并转换有效的菜单快捷键
  return exitMenu
    .filter((item) => {
      if (item.func) {
        // 门店功能直接放过
        return true;
      }
      if (item.menu === undefined) {
        // 空数组放过
        return true;
      }
      const [, secondMenuId] = item.menu;
      return authSecondMenuKeyMap.has(String(secondMenuId));
    })
    .map((item) => {
      // 处理空数组
      if (item.func) {
        // 功能增加name和icon
        const funcInfo = SHOP_FUNC_LIST.find((child) => child.value === item.func);
        return {
          ...item,
          name: funcInfo?.label,
          icon: FUNCTION_ICON[item.func],
        }; // 如果是功能快捷键，直接返回
      }
      // 集团菜单和门店菜单处理

      const [parentId, menuId] = item.menu || [];
      const menuInfo = authSecondMenuKeyMap.get(String(menuId));

      return {
        ...item,
        menu: menuInfo ? [menuInfo.id !== parentId ? menuInfo.id : parentId, menuId] : undefined,
        path: menuInfo?.secondMenuPath,
        name: menuInfo?.name,
        icon: menuInfo?.icon,
      };
    });
};

// 扁平化菜单数据
export const flattenMenus = (menus) => {
  const result = [];
  menus.forEach((menu) => {
    if (menu.children && menu.children.length > 0) {
      // 将当前菜单作为一级菜单
      result.push({
        value: menu.id,
        label: menu.name,
        children: menu.children.map((child) => ({
          value: child.id,
          label: child.name,
          path: child.path,
        })),
      });
    }
  });
  return result;
};

// 可用的功能快捷键
export const FUNCTION_SHORTCUT_KEYS = [
  'F1',
  'F2',
  'F3',
  'F4',
  'F6',
  'F7',
  'F8',
  'F9',
  'F10',
  'Alt+1',
  'Alt+2',
  'Alt+3',
  'Alt+4',
  'Alt+5',
  'Alt+6',
  'Alt+7',
  'Alt+8',
  'Alt+9',
  'Alt+0',
];

// 排除空的数据 门店菜单快捷键或功能快捷键
export const filterEmptyData = (data) => {
  const cacheData: Record<string, any> = {};
  Object.keys(data).forEach((key) => {
    cacheData[key] = data[key].filter((item) => {
      if (item.func && (item.key || item.id)) {
        return true;
      }
      if (item.menu && (item.key || item.id)) {
        return true;
      }
      return false;
    });
  });
  return cacheData;
};

export const filterMenuKey = (menus) => {
  // 二级菜单visible =1 显示 保持原来的树结构
  return menus.map((item) => {
    if (item.children && item.children.length > 0) {
      return {
        ...item,
        children: item.children.filter((child) => child.visible === 1),
      };
    }
    return item;
  });
};
